import { rankFor, type Tier } from '../../shared/ranks'
import { Icon } from './Icon'
import type { CSSProperties } from 'react'

/* What a person looks like everywhere: a photo or an icon on their profile color, inside their rank ring.
   Rank names never show here, only the ring's color. */
export interface Look {
  name?: string | null
  username?: string | null
  avatar?: string | null // photo URL
  icon?: string | null // a-* icon id
  color?: string | null
  xp?: number | null
  tier?: Tier | null
}

export function initialOf(look: Look) {
  const s = (look.name || look.username || '?').trim()
  const ch = Array.from(s)[0] || '?'
  return ch.toUpperCase()
}

export function Face({ look, size = 38 }: { look: Look; size?: number }) {
  return (
    <span className="av" style={{ '--pc': look.color || 'var(--multi)' } as CSSProperties}>
      {look.avatar ? <img src={look.avatar} alt="" loading="lazy" decoding="async" draggable={false} /> : look.icon ? <Icon id={look.icon} /> : <span style={{ fontSize: size * 0.42 }}>{initialOf(look)}</span>}
    </span>
  )
}

export function Avatar({ look, size = 38, ring, gap, tip, className }: { look: Look; size?: number; ring?: number; gap?: string; tip?: string; className?: string }) {
  const tier = look.tier ?? (look.xp != null ? rankFor(look.xp).tier : 'none')
  const rw = ring ?? Math.max(3, Math.round(size * 0.11))
  return (
    <span
      className={`ring t-${tier}${className ? ' ' + className : ''}`}
      style={{ '--sz': size + 'px', '--rw': tier === 'none' ? '0px' : rw + 'px', ...(gap ? { '--ring-gap': gap } : {}) } as CSSProperties}
      data-tip={tip}
    >
      <Face look={look} size={size} />
    </span>
  )
}
